<template>
  <div style="position: fixed; right: 20px; top: 300px;">
    <div @click="gos('https://jsyc.zjtwh.com/pc/h1.html')" style="margin-bottom: 20px;"><img src="https://file.storep.91haoka.cn/wulianwang/tu2.png" style="height: 100px;"></div>
    <div @click="gos('https://jsyc.zjtwh.com/pc/h2.html')" ><img src="https://file.storep.91haoka.cn/wulianwang/tu1.png" style="height: 100px;"></div>

  </div>
</template>

<script>
  export default {
    name: 'chuantu',
    data() {
      return {

      }
    },
    created() {

    },
    methods: {

    gos:function(url){
      window.open(url)
    }

    }
  }
</script>


<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/fudong.vue